/* ============================================================
   RTL i18n shim (MyPitz) — loaded only on RTL locales, right after
   rtl.css. Translates the collection SORT options and FILTER group
   labels that Shopify renders from platform strings (collection.
   sort_options[].name and Search & Discovery filter labels), which
   the theme's locales/he.json cannot reach. Exact-match only, and
   re-runs when Dawn re-renders the facets over AJAX.
   ============================================================ */
(function () {
  var DICT = {
    // sort options (#SortBy)
    'Featured': 'מומלצים',
    'Most relevant': 'הכי רלוונטי',
    'Best selling': 'הנמכרים ביותר',
    'Alphabetically, A-Z': 'לפי א׳-ת׳',
    'Alphabetically, Z-A': 'לפי ת׳-א׳',
    'Price, low to high': 'מחיר: מהנמוך לגבוה',
    'Price, high to low': 'מחיר: מהגבוה לנמוך',
    'Date, old to new': 'תאריך: מהישן לחדש',
    'Date, new to old': 'תאריך: מהחדש לישן',
    // filter group labels + values (Search & Discovery / default facets)
    'Availability': 'זמינות',
    'Price': 'מחיר',
    'In stock': 'במלאי',
    'Out of stock': 'אזל מהמלאי',
    'Brand': 'מותג',
    'Color': 'צבע',
    'Size': 'מידה'
  };

  // facet containers only — so a matching word ("Price") elsewhere on the
  // page (product titles, prices) is never touched.
  var FACET_SEL = '.facets,.mobile-facets,.facet-filters,[class*="facets"]';

  // Replace an exact-match text node (labels can sit in nested <span>s, so a
  // direct-child scan misses them — walk every text node in the container).
  function walkAndTranslate(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) {
      var t = nodes[i].nodeValue, trimmed = t.trim();
      if (trimmed && DICT[trimmed]) nodes[i].nodeValue = t.replace(trimmed, DICT[trimmed]);
    }
  }

  function translate(root) {
    root = root || document;
    // sort <option> elements — replace the whole label
    var opts = root.querySelectorAll('select option');
    for (var i = 0; i < opts.length; i++) {
      var ot = opts[i].textContent.trim();
      if (DICT[ot]) opts[i].textContent = DICT[ot];
    }
    // filter group labels + values (exact-match text nodes inside facets)
    var facets = root.querySelectorAll(FACET_SEL);
    for (var f = 0; f < facets.length; f++) walkAndTranslate(facets[f]);
  }

  function onCollectionish() {
    return /\/(collections|search)/.test(location.pathname) ||
      document.querySelector('#SortBy, .facets, .mobile-facets');
  }

  function run() { if (onCollectionish()) translate(document); }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // Dawn's FacetFiltersForm swaps the grid + facets over AJAX on
  // sort/filter — re-translate the freshly injected markup. Observe
  // childList only (our text edits don't retrigger it).
  document.addEventListener('DOMContentLoaded', function () {
    if (!onCollectionish()) return;
    var target = document.querySelector('#ProductGridContainer') ||
      document.querySelector('main') || document.body;
    if (!target) return;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { translate(document); return; }
      }
    });
    mo.observe(target, { childList: true, subtree: true });
  });
})();

/* Hide the sticky ATC whenever the main product Add-to-Cart button is in view, so it never covers it. */
(function(){
  var st=document.createElement('style');
  st.textContent='sticky-atc.mp-hide-sticky-atc{transform:translateY(160%)!important;visibility:hidden!important;pointer-events:none!important;}';
  (document.head||document.documentElement).appendChild(st);
  function initStickyAtcGuard(){
    var sticky=document.querySelector('sticky-atc');
    var main=document.querySelector('.product-form__submit');
    if(!sticky||!main||!window.IntersectionObserver) return;
    var io=new IntersectionObserver(function(entries){
      sticky.classList.toggle('mp-hide-sticky-atc', entries.some(function(e){return e.isIntersecting;}));
    }, { threshold: 0, rootMargin: '0px 0px 120px 0px' });
    io.observe(main);
  }
  if(document.readyState!=='loading') initStickyAtcGuard();
  else document.addEventListener('DOMContentLoaded', initStickyAtcGuard);
})();
